import { Icon, Typography } from '@/components';
import { ServiceItemList } from '@/features/services/types';

import { useTranslation } from 'react-i18next';
import { ServicesItems } from '@/features/services';
import { useMemo } from 'react';

export type ServicesItemsProps = {
  readonly services: ServiceItemList[];
};

export function OpportunityServices({ services }: ServicesItemsProps) {
  const { t } = useTranslation(['opportunities']);
  const isRecommended = true;

  if (services.length === 0) return null;
  const firstFourServices = useMemo(() => (services ?? []).slice(0, 4), [services]);

  return (
    <div className="w-full items-center justify-around gap-4 rounded-md border border-neutral-50 bg-white p-6">
      <div className="flex items-center">
        <div className="mr-2 flex h-10 w-10 items-center justify-center rounded-full bg-neutral-50">
          <Icon name="id-card" className="h-6 w-6" />
        </div>
        <Typography as="h3" weight="semibold" size="title">
          {t('Recommended Advisors')}
        </Typography>
      </div>
      <div className="inline-flex w-full items-center justify-around">
        <ServicesItems services={firstFourServices} isRecommended={isRecommended} />
      </div>
    </div>
  );
}
